module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/plan1-2-4a823fc49f2e36cfd187d4881629a685.webp";